import AccountTemplate from './AccountTemplate';

export default AccountTemplate;
